'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import useClientSideRouting from 'state/clientSideRoutingStore';
import useSoundsPreloadStore from 'state/soundsPreloadStore';

import useReportSessionData from 'hooks/useReportSessionData';

const NoPreloadedFallback = () => {
  const path = usePathname();
  const clientSidePath = useClientSideRouting(store => store.path);
  const initialPreloaded = useSoundsPreloadStore(
    store => store.initialPreloaded
  );
  const reportSessionData = useReportSessionData();

  useEffect(() => {
    // report session data is initialized as undefined
    // if no data is found it is set to null
    if (reportSessionData === undefined) return;

    if (path === '/address-not-supported') return;

    if (reportSessionData) {
      if (
        [
          '/landing',
          '/',
          '/thank-you',
          '/report',
          '/report/bushfire',
          '/report/storm',
          '/report/cyclone',
          '/report/flood',
          '/about-the-project',
        ].includes(path)
      )
        return;

      if (initialPreloaded) return;
    } else {
      if (['/landing', '/', '/about-the-project'].includes(path)) return;
      if (initialPreloaded) return;
    }

    window.location.replace('/landing');
  }, [path, clientSidePath, initialPreloaded, reportSessionData]);

  return null;
};

export default NoPreloadedFallback;
